<template>
  <div class="card-box" :class="{ 'video-card': videoCard }">
    <div class="box-header" v-if="boxData.titleImg">
      <div class="img-wrap">
        <img :src="boxData.titleImg" alt="" />
      </div>
    </div>
    <div
      v-if="boxData.title"
      class="box-title-content"
      :class="{
        color1: boxData.color1,
        color2: boxData.color2,
        videoBox: boxData.videoBox,
        box2: boxData.titleImg,
        advantage: boxData.advantage,
        zh: $i18n.locale === 'zh' || $i18n.locale === 'zh-tw',
        ja: $i18n.locale === 'ja',
        ko: $i18n.locale === 'ko',
        fr: $i18n.locale === 'fr',
        es: $i18n.locale === 'es',
      }"
    >
      {{ boxData.title }} <br />
      {{ boxData.title2 }}
    </div>
    <div
      v-if="boxData.desc"
      class="box-desc-content"
      :class="{
        box2: boxData.titleImg,
        advantage: boxData.advantage,
        color1: boxData.id && boxData.id !== 2,
        zh: $i18n.locale === 'zh' || $i18n.locale === 'zh-tw',
        ja: $i18n.locale === 'ja',
        ko: $i18n.locale === 'ko',
        fr: $i18n.locale === 'fr',
        es: $i18n.locale === 'es',
      }"
    >
      {{ boxData.desc }}
    </div>
    <div
      class="box-img-content"
      :class="{ advantage: boxData.advantage }"
      v-if="boxData.img"
    >
      <img :src="boxData.img" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    boxData: {
      type: Object,
      default: Object,
    },
    videoCard: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  // border-radius: 0.32rem;
  // padding: 0.48rem 0;
  background: #ffffff;
  border-radius: 0.32rem;
  // box-shadow: 0px 0.1rem 0.48rem 0px rgba(44, 55, 92, 0.15);
  &.video-card {
    background: #ffffff;
    border-radius: 0.32rem;
    // border-left: 0.01rem solid #6f7174;
    // border-right: 0.01rem solid #6f7174;
  }
  .box-header {
    margin-top: 0.48rem;
    .img-wrap {
      margin-left: 0.3rem;
      display: flex;
      img {
        width: 1.08rem;
        height: 1.08rem;
      }
    }
  }
  .box-title-content {
    font-size: 0.48rem;
    font-family: 'Bold';
    text-align: center;
    color: #ffffff;
    padding: 0.48rem 0.48rem 0;
    font-weight: 500;
    &.videoBox {
      text-align: left;
    }
    &.box2 {
      margin-top: 0.14rem;
      padding: 0 0.48rem;
      font-size: 0.28rem;
      text-align: left;
      line-height: 0.4rem;
      &.zh {
        min-height: 0.8rem;
      }
      &.ja {
        min-height: 1.2rem;
      }
      &.ko {
        min-height: 0.8rem;
      }
      &.fr {
        min-height: 1.6rem;
      }
      &.es {
        min-height: 1.6rem;
      }
    }
    &.color1 {
      color: #ffffff;
    }
    &.color2 {
      color: #181818;
      // line-height: 0.56rem;
    }
    &.advantage {
      padding: 0;
      line-height: normal;
      &.es {
        min-height: 1.2rem;
      }
    }
  }
  .box-desc-content {
    padding: 0 0.48rem;
    margin-top: 0.48rem;
    color: #181818;
    font-size: 0.2rem;
    line-height: 0.3rem;
    // font-family: 'Medium';
    font-family: 'Inter-Regular';
    &.box2 {
      color: #9ea0a5;
      margin: 0.16rem 0 0.4rem;
      min-height: 1.5rem;
      font-size: 0.2rem;
      &.zh {
        min-height: 0.9rem;
      }
      &.ja {
        min-height: 1.2rem;
      }
      &.ko {
        min-height: 0.9rem;
      }
      &.fr {
        min-height: 1.5rem;
      }
      &.es {
        min-height: 1.5rem;
      }
    }
    &.advantage {
      margin-top: 0.16rem;
      text-align: center;
      padding: 0;
      &.zh {
        min-height: 0.9rem;
      }
      &.ja {
        min-height: 0.9rem;
      }
      &.ko {
        min-height: 0.9rem;
      }
      &.fr {
        min-height: 1.5rem;
      }
      &.es {
        min-height: 1.5rem;
      }
    }
    &.color1 {
      color: #fff;
    }
    &.color2 {
      color: #fff;
    }
  }
  .box-img-content {
    display: flex;
    justify-content: center;
    width: 100%;
    &.advantage {
      margin-top: 0.46rem;
      img {
        width: 1.68rem;
        height: 1.68rem;
      }
    }
    img {
      width: 100%;
      object-fit: contain;
      border-radius: 0 0 0.32rem 0.32rem;
    }
  }
}
@media screen and (max-width: 767px) {
  .card-box {
    border-radius: 0.36rem;
    &.video-card {
      border: none;
    }
    .box-header {
      // margin-top: 0.48rem;
      .img-wrap {
        // margin-left: 0.3rem;
        // display: flex;
        img {
          width: 1.68rem;
          height: 1.68rem;
        }
      }
    }
    .box-title-content {
      text-align: left;
      margin-top: 0;
      padding: 0.48rem 0;
      font-size: 0.53rem;
      font-weight: 700;
      &.videoBox {
        padding: 0.56rem 0.56rem 0;
      }
      &.advantage {
        text-align: center;
        font-size: 0.54rem;
      }
      &.box2 {
        font-size: 0.48rem;
        line-height: 0.6rem;
      }
    }
    .box-desc-content {
      font-size: 0.36rem;
      line-height: 0.54rem;
      &.advantage {
        margin-top: 0.3rem;
        padding: 0 0.4rem;
        font-size: 0.32rem;
      }
      &.box2 {
        line-height: 0.33rem;
        font-size: 0.26rem;
      }
    }
    .box-img-content {
      &.advantage {
        margin-top: 0.9rem;
        img {
          width: 3rem;
          height: 3rem;
        }
      }
    }
  }
}
</style>
